export var FeeType;
(function (FeeType) {
    FeeType["DOLLAR"] = "dollar";
    FeeType["PERCENTAGE"] = "percentage";
})(FeeType || (FeeType = {}));
//# sourceMappingURL=FeeType.js.map